import { Component } from '@angular/core';

/**
 * Generated class for the AnimalsIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'animals-icon',
  templateUrl: 'animals-icon.html'
})
export class AnimalsIconComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/animals-icon/animals-icon.ts